export default {
      id: "psb-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#psb",
      toString: function () {
        return this.url;
      }
    }